import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import signupImage from "../images/signup.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import avr1 from "../images/avr1.png";
import avr2 from "../images/avr2.png";
import avr3 from "../images/avr3.png";
import avr4 from "../images/avr4.png";
import avr5 from "../images/avr5.png";
import avr6 from "../images/avr6.png";
import avr7 from "../images/avr7.png";
import avr8 from "../images/avr8.png";
import avr9 from "../images/avr9.png";
import avr10 from "../images/avr10.png";
import avr11 from "../images/avr11.png";
import avr12 from "../images/avr12.png";
import Colors from "../components/Colors";
import TextfieldComponent from "../components/TextfeildComponent";

function BackToBenchSignIn() {
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [nameError, setNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [signinError, setSigninError] = useState("");
  const [isCheckedSignIn, setisCheckedSignIn] = useState(false);

  const [forgotPasswordData, setForgotPasswordData] = useState({
    countryCode: "",
    phoneNumber: "",
  });

  const passwordMap = {
    lion: avr1,
    tiger: avr2,
    squirrel: avr3,
    pig: avr4,
    rabbit: avr5,
    cat: avr6,
    blueberry: avr7,
    mango: avr8,
    apple: avr9,
    orenge: avr10,
    strawberry: avr11,
    grape: avr12,
  };

  const extractAnimalAndFruit = (password) => {
    let clickedAnimal = null;
    let clickedFruit = null;

    // Iterate over the keys in passwordMap
    for (const animal in passwordMap) {
      if (password.startsWith(animal)) {
        // If the password starts with an animal name
        clickedAnimal = animal;
        const remainingPart = password.slice(animal.length); // Remove the animal part

        // Check if the remaining part is a fruit in the passwordMap
        for (const fruit in passwordMap) {
          if (remainingPart === fruit) {
            clickedFruit = fruit;
            break;
          }
        }
        break;
      }
    }

    return { clickedAnimal, clickedFruit };
  };

  const [selectedAnimal, setSelectedAnimal] = useState("");
  const [selectedFruit, setSelectedFruit] = useState("");

  // Separate animals and fruits
  const animals = Object.keys(passwordMap).slice(0, 6);
  const fruits = Object.keys(passwordMap).slice(6);

  const fetchPassword = async () => {
    try {
      const response = await axios.post(`${API_URL}/decode_password`, {
        password: localStorage.getItem("rememberedPassword"),
      });
      if (response.data.success === true) {
        setPassword(response.data.password);
        setisCheckedSignIn(true);
        const { clickedAnimal, clickedFruit } = extractAnimalAndFruit(
          response.data.password,
        );
        setSelectedAnimal(clickedAnimal);
        setSelectedFruit(clickedFruit);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAnimalSelect = (animal) => {
    setSelectedAnimal(animal);
    setPassword(`${animal}${selectedFruit}`);
    setPasswordError("");
    setSigninError("");
  };

  const handleFruitSelect = (fruit) => {
    setSelectedFruit(fruit);
    setPassword(`${selectedAnimal}${fruit}`);
    setPasswordError("");
    setSigninError("");
  };

  const handleCountryCodeChange = (e) => {
    let newValue = e.target.value;
    if (/^\+?\d*$/.test(newValue)) {
      if (newValue.length <= 4) {
        setCountryCode(newValue);
      }
    }
    setCountryCodeError("");
    setPhoneNumberError("");
    setSigninError("");
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    setNameError("");
    setSigninError("");
  };

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue) && newValue.length <= 10) {
      setPhoneNumber(newValue);
    }
    setPhoneNumberError("");
    setCountryCodeError("");
    setSigninError("");
    const savedCountryCode = localStorage.getItem("rememberedCountryCode");
    const savedPhone = localStorage.getItem("rememberedPhone");
    const savedPassword = localStorage.getItem("rememberedPassword");

    if (
      savedPhone &&
      e.target.value === savedPhone &&
      countryCode === savedCountryCode
    ) {
      fetchPassword();
    } else {
      setisCheckedSignIn(false);
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError("");
    setSigninError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const sanitizeName = (name) => name.trim();

  // Handle form submission (Register button click)
  const handleSignIn = async () => {
    const country = countryCode.replace(/^\+/, "");

    if (country.trim() === "") {
      setCountryCodeError("Please enter your country code");
    } else if (phoneNumber.trim() === "") {
      setPhoneNumberError("Please enter your phone number");
    } else {
      try {
        const response = await axios.post(
          `${API_URL}/select_back_to_bench_details`,
          {
            // name: playerName,
            countryCode: country,
            phone: phoneNumber,
            //  password: password,
            //  rememberMe: isCheckedSignIn
          },
        );
        setSigninError(response.data.error);
        if (response.data.success === true) {
          localStorage.removeItem("PlayerTocken");
          localStorage.removeItem("TimelessTiesTocken");
          localStorage.setItem("BackToBenchTocken", response.data.token);
          window.location.href = "/all-game";
        }
      } catch (error) {
        console.error("something went wrong", error);
      }
    }
  };

  const handleSignUpButtonClick = () => {
    window.location.href = "/player-signup";
  };

  const handleForgotPasswordClick = async () => {
    window.location.href = "/forgot-password";
    localStorage.setItem("forgotcountry", countryCode);
    localStorage.setItem("forgotphone", phoneNumber);
    localStorage.setItem("forgotname", name);
  };

  const handleCheckboxChange = (event) => {
    setisCheckedSignIn(event.target.checked);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        background: Colors.Tidesbg,
        width: "100%",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          background: Colors.signupboxbg,
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { md: "40%", xs: "90%" },
          maxHeight: { md: "50%", xs: "37%" },
          borderRadius: "28px",
          borderColor: Colors.signupBorder,
          border: "2px solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
            gap: "32px",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: "95%", xs: "85%" },
            maxHeight: "90%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { md: "80%", xs: "100%" },
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "28px",
                  fontWeight: 600,
                  color: "#fff",
                }}
              >
                Welcome !
              </Typography>

              {/* <Box sx={{display:'flex', flexDirection:'column', width:'100%', height:'fit-content',
                                     justifyContent:'center', alignItems:'flex-start', gap:'4px' }}>
                                    <Typography sx={{fontFamily:'Roboto', fontSize:{xs:'12px', md:'14px'}, fontWeight:400}}>Nick name:</Typography>
                                    <TextField  value={name} onChange={handleNameChange}
                                    fullWidth
                                    inputProps={{ 
                                        sx: { 
                                          height: { md: '32px', xs: '28px' }, 
                                          padding: '4px 10px',
                                          fontSize: { md: '14px', xs: '12px' } 
                                        } 
                                      }}
                                    sx={{
                                      borderRadius: '8px',
                                    }}/>
                                     {nameError && <Typography sx={{color:'red', fontFamily:'Roboto', fontSize:{xs:'12px', md:'14px'}, fontWeight:400}}>
                                     {nameError}</Typography>}
                                </Box>
                */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "12px",
                }}
              >
                <Box sx={{ width: { md: "20%", xs: "35%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Country code:
                  </Typography>
                  <TextfieldComponent
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                  />
                </Box>
                <Box sx={{ width: { md: "80%", xs: "65%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Phone number:
                  </Typography>
                  <TextfieldComponent
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                  />
                </Box>
              </Box>
              {countryCodeError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {countryCodeError}
                </Typography>
              )}
              {phoneNumberError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {phoneNumberError}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  padding: { md: "0px", xs: "0px" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                ></Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                  marginTop: { md: "16px", xs: "0px" },
                }}
              >
                <Button
                  onClick={handleSignIn}
                  sx={{
                    background: Colors.button2,
                    color: Colors.button2font,
                    height: { md: "36px", xs: "32px" },
                    width: "100%",
                    border: "1px solid",
                    borderColor: Colors.button2Border,
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    transition: "background 0.3s, transform 0.3s",
                    "&:hover": {
                      background: Colors.button2,
                      transform: "scaleY(1.05)",
                    },
                    "&:active": {
                      background: Colors.button2,
                    },
                  }}
                >
                  Play Game
                </Button>

                {signinError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {signinError}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default BackToBenchSignIn;
